import { render, staticRenderFns } from "./AdminSuprazonesTableRow.vue?vue&type=template&id=21869190&"
import script from "./AdminSuprazonesTableRow.vue?vue&type=script&lang=js&"
export * from "./AdminSuprazonesTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports